import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, display, mb, mr, onDesktop, p, truncateMultiline} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {AIMarkingBadge, getAIMarkingTypeFromFlags} from "@pg-mono/ai-marking";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

interface IProps {
    className?: string;
    imageLoading?: HTMLImageElement["loading"];
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        excerpt: string;
        gallery: (
            | {
                  image_url: string | null;
              }
            | undefined
        )[];
        id: number;
        slug: string;
        title: string;
        lead: string | null;
        ai_created: boolean;
        ai_modified: boolean;
    };
}

export const BlogFeaturedCard = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const blogCardHandler = () => {
        window.open(articleLink, responsiveLinkTarget);
    };
    const aiMarkingBadgeType = getAIMarkingTypeFromFlags({isModified: article.ai_modified, isCreated: article.ai_created});

    return (
        <div className={props.className} css={articleListBox} onClick={blogCardHandler}>
            {article.gallery[0]?.image_url && (
                <div css={pictureWrapper}>
                    {aiMarkingBadgeType ? <AIMarkingBadge type={aiMarkingBadgeType} transparent css={aiMarkingBadge} /> : null}
                    <Picture
                        css={picture}
                        sources={[
                            {
                                minWidthPX: 0,
                                src: getThumbnailLink(article.gallery[0]?.image_url, 349, 239),
                                width: 206,
                                height: 206
                            },
                            {
                                minWidthPX: 360,
                                src: getThumbnailLink(article.gallery[0]?.image_url, 572, 315),
                                width: 572,
                                height: 315
                            }
                        ]}
                        alt={article.title}
                        loading={props.imageLoading}
                    />
                </div>
            )}

            <div css={[p(4)]}>
                <Text css={mb(2)} as="div" variant="info_txt_2">
                    <div css={[display("inline-block"), mr(3)]}>{formatDate(article.date_published, dateTimeFormat.shortDate)}</div>
                    <div css={[display("inline-block")]}>{article.author.name}</div>
                </Text>

                <a className={props.className} href={articleLink} target={responsiveLinkTarget} css={link}>
                    <Text css={onDesktop(mb(2))} as="h2" variant="headline_4">
                        {article.title}
                    </Text>
                </a>
                <Text css={[display("none"), onDesktop(display("block"), truncateMultiline(4))]} variant="body_copy_1">
                    {article.lead}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = (theme: Theme) => css`
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #fff;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }

    max-width: 57.2rem;

    ${onDesktop(css`
        width: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        max-width: unset;
    `)}
`;

const link = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        text-decoration: none;
    }
`;

const pictureWrapper = css`
    position: relative;
    flex-shrink: 0;
`;

const picture = css`
    overflow: hidden;
    flex-shrink: 0;
    ${borderRadius(2, 2, 0, 0)};

    ${onDesktop(css`
        ${borderRadius(2, 0, 0, 2)}
    `)};
`;

const aiMarkingBadge = css`
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    z-index: 2;
    height: 1.6rem;
    width: auto;

    ${onDesktop(css`
        top: 1.6rem;
        left: 1.6rem;
        height: 2rem;
    `)};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, display, mb, mr, onDesktop, p, truncateMultiline} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {AIMarkingBadge, getAIMarkingTypeFromFlags} from "@pg-mono/ai-marking";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

interface IProps {
    className?: string;
    imageLoading?: HTMLImageElement["loading"];
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        excerpt: string;
        gallery: (
            | {
                  image_url: string | null;
              }
            | undefined
        )[];
        id: number;
        slug: string;
        title: string;
        lead: string | null;
        ai_created: boolean;
        ai_modified: boolean;
    };
}

export const BlogFeaturedCard = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const blogCardHandler = () => {
        window.open(articleLink, responsiveLinkTarget);
    };
    const aiMarkingBadgeType = getAIMarkingTypeFromFlags({isModified: article.ai_modified, isCreated: article.ai_created});

    return (
        <div className={props.className} css={articleListBox} onClick={blogCardHandler}>
            {article.gallery[0]?.image_url && (
                <div css={pictureWrapper}>
                    {aiMarkingBadgeType ? <AIMarkingBadge type={aiMarkingBadgeType} transparent css={aiMarkingBadge} /> : null}
                    <Picture
                        css={picture}
                        sources={[
                            {
                                minWidthPX: 0,
                                src: getThumbnailLink(article.gallery[0]?.image_url, 349, 239),
                                width: 206,
                                height: 206
                            },
                            {
                                minWidthPX: 360,
                                src: getThumbnailLink(article.gallery[0]?.image_url, 572, 315),
                                width: 572,
                                height: 315
                            }
                        ]}
                        alt={article.title}
                        loading={props.imageLoading}
                    />
                </div>
            )}

            <div css={[p(4)]}>
                <Text css={mb(2)} as="div" variant="info_txt_2">
                    <div css={[display("inline-block"), mr(3)]}>{formatDate(article.date_published, dateTimeFormat.shortDate)}</div>
                    <div css={[display("inline-block")]}>{article.author.name}</div>
                </Text>

                <a className={props.className} href={articleLink} target={responsiveLinkTarget} css={link}>
                    <Text css={onDesktop(mb(2))} as="h2" variant="headline_4">
                        {article.title}
                    </Text>
                </a>
                <Text css={[display("none"), onDesktop(display("block"), truncateMultiline(4))]} variant="body_copy_1">
                    {article.lead}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = (theme: Theme) => css`
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #fff;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }

    max-width: 57.2rem;

    ${onDesktop(css`
        width: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        max-width: unset;
    `)}
`;

const link = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        text-decoration: none;
    }
`;

const pictureWrapper = css`
    position: relative;
    flex-shrink: 0;
`;

const picture = css`
    overflow: hidden;
    flex-shrink: 0;
    ${borderRadius(2, 2, 0, 0)};

    ${onDesktop(css`
        ${borderRadius(2, 0, 0, 2)}
    `)};
`;

const aiMarkingBadge = css`
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    z-index: 2;
    height: 1.6rem;
    width: auto;

    ${onDesktop(css`
        top: 1.6rem;
        left: 1.6rem;
        height: 2rem;
    `)};
`;
